export default __webpack_public_path__ + "static/media/note-file.b56381d3.svg";